var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-card',{attrs:{"bordered":false}},_vm._l((_vm.previewContent),function(line,index){return (index < 5)?_c('span',{key:index},_vm._l((line),function(item,i){return (i < 5)?_c('a-card-grid',{key:item,style:(`width:${100/line.length}%`)},[_c('MarketRtChart',{attrs:{"code":item}})],1):_vm._e()}),1):_vm._e()}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }